import Pqp from "../../3x1010/Pqp.js";
export default class Vengine {

	constructor(mc, dir, url) {
		this.mc = mc;
		this.dir = dir;
		this.url = url;
		this.video = jQuery(".js-vidle", mc);
		this.videoAction = jQuery(".js-vaction", mc);
		this.input = jQuery(".js-vinput", mc);
		this.submit = jQuery(".js-vbutton", mc);
		this.player = null;
		this.playerAction = null;
		this.idle = true;
		jQuery(".js-vinput", this.mc).val("");
		if (Pqp.isIos()) {
			jQuery(".js-vinput", this.mc).addClass("vengine-input-ios")
    }
	}

	init() {
		this.initIdle();
		this.loadConfig();
	}


	loadConfig() {
		$.ajax({
			type: "GET",
			url: this.url,
			success: this.configLoaded.bind(this),
			error: this.errorLoadingCore.bind(this)
		});
	}

	configLoaded(data) {
		let csv = $.csv.toArrays(data);
		this.cfg = this.toArrayObject(csv)
		this.initKeyboardAndButton();
	}

	errorLoadingCore() {
		alert("Caricamento errato, riprova!");
	}

	toArrayObject(csv) {
		let ret = new Array();
		for (let x = 1; x < csv.length; x++) {
			let o = new Object();
			for (let y = 0; y < csv[0].length; y++) {
				o[csv[0][y]] = csv[x][y];
			}
			ret.push(o)
		}
		return ret;
	}


	initIdle() {
		let vid = this.createTag();
		let options = {
			controls: false,
			loop: true
		}
		jQuery("source", vid).attr("src", this.dir + "videos/idle.m4v");
		//jQuery("source", vid).attr("src", "http://vjs.zencdn.net/v/oceans.mp4");
		
		this.video.append(vid);
		this.player = videojs(vid.get(0), options);

		this.video.css("z-index", 10);
		this.player.ready(() => {
			this.player.autoplay("muted");
			requestAnimationFrame(this.checkIsPlaying.bind(this));
		});

		vid = this.createTag();
		jQuery("source", vid).attr("src", this.dir + "videos/idle.m4v");
		this.videoAction.append(vid);
		this.playerAction = videojs(vid.get(0), options);

		this.videoAction.css("z-index", 5);
		this.playerAction.ready(() => {
			this.playerAction.autoplay("muted");
		});

	}
	checkIsPlaying() {
		if (!this.counterCheckStarted) {
			this.counterCheckStarted = 0;
		}
		this.counterCheckStarted++;
		if (this.counterCheckStarted > Vengine.CHECK_VIDEO_STARTED_AFTER) {
			if (!this.player.paused()) {
				// Okay è partito, toglie lo schermo nero
				this.turnOnTv(false);
			} else {
				if (this.counterCheckStarted > 120) {
					// Due secondi e non è partito, fa comparire la scritta play
					jQuery(".js-msg-start", this.mc).css("opacity", 1);
					jQuery(".js-msg-start", this.mc).show();
					jQuery(".js-msg-start", this.mc).on("click", this.turnOnTv.bind(this, true));

				} else {
					requestAnimationFrame(this.checkIsPlaying.bind(this));
				}
			}
		} else {
			requestAnimationFrame(this.checkIsPlaying.bind(this));
		}
	}

	videoStartedSuccesfully() {
		jQuery(".js-turnedoff", this.mc).hide();
		jQuery(".js-area-input", this.mc).show();

	}

	turnOnTv(start) {
		if (start) {
			this.player.autoplay("muted");
			this.playerAction.autoplay("muted");
		}
		jQuery(".js-msg-start", this.mc).hide();
		jQuery(".js-turnedoff", this.mc).css("background-image", "url('" + this.dir + "turnon.gif')");
		setTimeout(this.tvTurnedOn.bind(this), 960);

		//this.videoStartedSuccesfully();
		//console.log("A")
	}
	tvTurnedOn() {
		this.videoStartedSuccesfully();
		this.input.focus();
	}


	createTag() {
		let vid = jQuery("<video class='video-js vjs-default-skin vjs-fill' playsinline></video>");
		let src = jQuery("<source src='' type='video/mp4'>");
		vid.append(src);
		return vid;
	}

	initKeyboardAndButton() {
		this.input.removeAttr("disabled");
		this.input.on("keyup", this.onKeyUp.bind(this));
		this.checkSubmit();
		this.submit.on("click", this.parseCommand.bind(this));
	}

	checkSubmit() {
		let word = Pqp.removeDiacritics(this.input.val().toLowerCase());
		if (word.length >= Vengine.MINIMUM_CHAR_FOR_COMMAND) {
			this.submit.removeClass("btn-disabled")
		} else {
			this.submit.addClass("btn-disabled")
		}

	}

	onKeyUp(e) {
		this.checkSubmit();

		if (e.keyCode === 13) {
			this.parseCommand();
		}
	}

	parseCommand() {
		let word = Pqp.removeDiacritics(this.input.val().toLowerCase());
		if (word.length > 0) {
			let rq = {
				phrase: word,
				id: this.dir,
      }

			let toSend = {
				type: "POST",
				url: "http://www.virtualqueens.net/ita/logga.asp",
				data: rq
			}
			$.ajax(toSend);

			this.translate(word);
		}
	}

	soundex(strWord) {
		var strSoundex, strChar, strLastChar, intCount;	// local variables
		strSoundex = strWord.charAt(0).toUpperCase();  // get first character of word
		intCount = 1;  // next time thru loop get character no. 2

		// Check each subsequent character and encode until 4 character limit
		while ((strSoundex.length < 4) && (intCount <= strWord.length)) {
			strChar = this.getSoundCode(strWord.charAt(intCount));
			if (strLastChar != strChar) // no duplicates allowed
				strSoundex = strSoundex + strChar; // build Soundex code
			strLastChar = strChar; // update last character checked
			intCount++; // next character number in word
		}
		// Here's the return value: limit/pad to four characters
		strSoundex = strSoundex + "000";
		return strSoundex.substr(0, 4);
	}


	getSoundCode(strChar) {
		switch (strChar.toUpperCase()) {
			case "B":
			case "F":
			case "P":
			case "V":
				return "1";
			case "C":
			case "G":
			case "J":
			case "K":
			case "Q":
			case "S":
			case "X":
			case "Z":
				return "2";
			case "D":
			case "T":
				return "3";
			case "L":
				return "4";
			case "M":
			case "N":
				return "5";
			case "R":
				return "6";
		}
	}

	translate(word) {
		// Controlla prima se matcha esattamente
		let a = this.cfg;
		let lFound = false;
		for (let x = 0; x < a.length - 1; x++) {
			let keys = a[x].keys.split(",");
			for (let y = 0; y < keys.length; y++) {
				let key = jQuery.trim(keys[y]);
				if (!Pqp.isNullOrEmpty(key)) {
					if (word === key) {
						this.showVideo(a[x]);
						lFound = true;
						break;
					}
				}
			}
			if (lFound) {
				break;
			}
		}

		// Controlla il soundex
		/*if (!lFound) {
			for (let x = 0; x < a.length - 1; x++) {
				let keys = a[x].keys.split(",");
				for (let y = 0; y < keys.length; y++) {
					let key = jQuery.trim(keys[y]);
					if (!Pqp.isNullOrEmpty(key)) {
						console.log(this.soundex(word), this.soundex(key))
						if (this.soundex(word) === this.soundex(key)) {
							this.showVideo(a[x]);
							lFound = true;
							break;
						}
					}
				}
				if (lFound) {
					break;
				}
			}
		}*/

		// Se non l'ha trovato mostra il video che non capisce
		if (!lFound) {
			this.showVideo(a[a.length - 1]);
		}

	}

	showVideo(o) {
		if (Pqp.isIos()) {
			this.input.attr("disabled", "disabled");
			this.submit.addClass("btn-disabled")
			if (Pqp.isNullOrEmpty(o.video)) {
				this.showVideo(this.cfg[this.cfg.length - 1]);
			} else {
				this.showActionVideo(o.video);
			}
		} else {
			this.input.attr("disabled", "disabled");
			this.submit.addClass("btn-disabled")

			if (Pqp.isNullOrEmpty(o.extra)) {
				this.showActionVideo(o.video);
			} else if (Pqp.isNullOrEmpty(o.video)) {
				this.showYouTubeVideo(o.extra)
			} else {
				let prob = parseInt(o.probExtra) / 100;
				if (Pqp.check(prob)) {
					this.showYouTubeVideo(o.extra)
				} else {
					this.showActionVideo(o.video);
				}
			}
		}
	}

	showActionVideo(video) {
		let tmp = video.split(",")
		video = jQuery.trim(tmp[Pqp.rnd(tmp.length - 1)]);
		this.idle = false;
		this.playerAction.loop(false);
		this.playerAction.src({ type: 'video/mp4', src: this.dir + "videos/" + video + ".m4v" });
		//this.playerAction.src({	type: 'video/mp4', src: "http://vjs.zencdn.net/v/oceans.mp4" });
		this.playerAction.on("ended", this.actionVideoEnded.bind(this))
		this.counterCheckStarted = 0;
		requestAnimationFrame(this.checkActionStarted.bind(this));
	}

	checkActionStarted() {
		this.counterCheckStarted++;
		if (this.counterCheckStarted > Vengine.CHECK_VIDEO_STARTED_AFTER) {
			if (!this.player.paused()) {
				// Okay è partito, swappa lo zindex
				this.videoAction.css("z-index", 15);
			} else {
				requestAnimationFrame(this.checkActionStarted.bind(this));
			}
		} else {
			requestAnimationFrame(this.checkActionStarted.bind(this));
		}
	}


	actionVideoEnded(e) {
		if (!this.idle) {
			this.videoAction.css("z-index", 5);
			this.playerAction.loop(true);
			this.playerAction.src({ type: 'video/mp4', src: this.dir + "videos/idle.m4v" });
			this.idle = true;

			this.resetInputStatus()

		}
	}

	resetInputStatus() {
		this.input.removeAttr("disabled");
		jQuery(".js-vinput", this.mc).val("");
		jQuery(".js-vinput", this.mc).focus();
		this.checkSubmit();
	}

	showYouTubeVideo(videos) {
		videos = Pqp.safeReplace(videos, " ", "");
		let tmp = videos.split(",");
		let video = tmp[Pqp.rnd(tmp.length - 1)];
		let id = "yt" + (Vengine.ENUM++);
		let div = jQuery("<div class='video-panel js-yt' id='" + id + "'></div>")
		//div.css("pointer-events", "none");
		jQuery(".js-area-video", this.mc).append(div);

		this.ytplayer = new YT.Player(id, {
			height: '100%',
			width: '100%',
			videoId: video,
			playerVars: {
				"enablejsapi": 1,
				"autoplay": 1,
				"controls": 0,
				"disablekb": 1,
				"modestbranding": 1,
				"playsinline": 1,
				"showinfo": 0
			},
			events: {
				'onReady': this.onPlayerReady.bind(this),
				'onStateChange': this.onPlayerStateChange.bind(this)
			}
		});

	}
	onPlayerReady() {
		this.ytplayer.playVideo();
	}
	onPlayerStateChange(e) {
		if (e.data === 0) {
			this.ytplayer.destroy();
			jQuery(".js-yt", this.mc).remove();
			this.resetInputStatus();
		}

	}




}

Vengine.CHECK_VIDEO_STARTED_AFTER = 60;
Vengine.MINIMUM_CHAR_FOR_COMMAND = 3;
Vengine.ENUM = 0;